import Section from "@/components/Section";
import { Typography } from "@mui/material";
import MeetInDetailsTabs from "./components/MeetInDetailsTabs";

const MeetInDetailsSection = () => {
  return (
    <Section
      pt={{ xs: 0, lg: 12.5}}
      pb={{ xs: 0, lg: 12.5}}
    >
      <Typography variant="h2" sx={{ marginBottom: { xs: "32px", lg: "40px"} }}>Trackmate Essentials </Typography>
      <MeetInDetailsTabs />
    </Section>
  );
};

export default MeetInDetailsSection;